<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="pdfDomClass" id="pdfDom" ref="pdfDom">
    <div class="innerPdfDomClass" ref="innerDom">
      <p class="docTitle">共享航次计划{{pdfItem.applyNo.substring(0,4)}}年度搭载需求申请表</p>

      <!-- <div class="pdf-line">
        <span class="pdf-title">申请号：</span>
        <span class="pdf-content">{{ pdfItem.id }}</span>
      </div>-->

      <div class="pdf-line">
        <span class="pdf-title">项目批准号：</span>
        <span class="pdf-content">{{ pdfItem.prjNum }}</span>
      </div>

      <div class="pdf-line">
        <span class="pdf-title">项目名称：</span>
        <span class="pdf-content">{{ pdfItem.prjName }}</span>
      </div>

      <div class="pdf-line">
        <spam class="pdf-title">依托单位：</spam>
        <spam class="pdf-content">{{ pdfItem.unitName }}</spam>
        <div
          style="display:inline;float:right;min-width:180px;border-left:solid 2px #000;padding-left:5px"
        >
          <span class="pdf-title">项目类型：</span>
          <span class="pdf-content">{{ pdfItem.prjType }}</span>
        </div>
      </div>

      <div class="pdf-line">
        <spam class="pdf-title">项目负责人：</spam>
        <spam class="pdf-content">{{ pdfItem.appPerson }}</spam>
        <div
          style="display:inline;float:right;min-width:180px;border-left:solid 2px #000;padding-left:5px"
        >
          <span class="pdf-title">搭载申请提交人：</span>
          <span class="pdf-content">{{ pdfItem.itvTime }}</span>
        </div>
      </div>

      <div class="pdf-line">
        <span class="pdf-title">实际出海考察人员：</span>
        <span class="pdf-content">{{ pdfItem.operatorsStr }}</span>
      </div>

      <div class="pdf-line">
        <span class="pdf-title">海区：</span>
        <span class="pdf-content">{{ pdfItem.ocnArea }}</span>

        <div
          style="display:inline;float:right;min-width:180px;border-left:solid 2px #000;padding-left:5px"
        >
          <span class="pdf-title">学科代码：</span>
          <span class="pdf-content">{{ pdfItem.sbjNum }}</span>
        </div>
      </div>

      <div class="pdf-line">
        <span class="pdf-title">项目起止时间：</span>
        <span class="pdf-content">{{ pdfItem.startTime}} 至 {{pdfItem.endTime }}</span>
      </div>

      <div class="pdf-line">
        <span class="pdf-title">季节：</span>
        <span class="pdf-content">{{ pdfItem.seasonStr }}</span>
      </div>

      <div class="pdf-line" style="line-height:20px">
        <span class="pdf-title">调查内容：</span>
        <spam class="pdf-content">{{ pdfItem.proj }}</spam>
      </div>

      <div class="pdf-line" style="line-height:20px">
        <span class="pdf-title">备注：</span>
        <span class="pdf-content">{{ pdfItem.remark }}</span>
      </div>

      <!-- <div class="pdf-line">
        <span class="pdf-title">是否搭载过国家自然科学基金共享航次计划：</span>
        <span class="font12">
          <span style="margin-left:10px">
            <span v-if="pdfItem.carryStatus == 1">√</span>是
          </span>
          <span style="margin-left:30px">
            <span v-if="pdfItem.carryStatus == 0">√</span>否
          </span>
        </span>
      </div>-->

      <!-- <div class="pdf-line">
        <span class="pdf-title">共享航次考察资料是否汇交：</span>
        <span class="font12">
          <span style="margin-left:10px">
            <span v-if="pdfItem.dataStatus == 1">√</span>是
          </span>
          <span style="margin-left:30px">
            <span v-if="pdfItem.dataStatus == 0">√</span>否
          </span>
        </span>
      </div>-->

      <div class="pdf-line" style="line-height:25px">
        <span class="pdf-title">项目负责人签字：</span>
        <span class="font12" style="display:block;margin-left:300px">
          <div class="bottomLine50" />年
          <div class="bottomLine25" />月
          <div class="bottomLine25" />日
        </span>
      </div>

      <div class="pdf-line" style="border-bottom:1px solid #000;line-height:50px">
        <span class="pdf-title">项目依托单位盖章：</span>
        <span class="font12" style="display:block;margin-left:300px">
          <div class="bottomLine50" />年
          <div class="bottomLine25" />月
          <div class="bottomLine25" />日
        </span>
      </div>

      <!-- <div class="pdf-line"> -->
      <div style="margin-left:20px;margin-top:20px" v-if="pdfItem.attatchmentStr">
        <p class="pdf-title">附件：</p>
        <img :src="pdfItem.attatchmentStr" style="margin:10px;max-width:450px" />
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import LinkComponent from '@/components/LinkComponent.vue';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';
import Vue from 'vue';
import { requestSvApply } from '@/api/SvpConfig';
import htmlToPdf from '../../utils/htmlToPdf';
import { formatDate } from '@/utils/date';

export default {
  components: { LinkComponent },
  name: 'ApplyPdf',
  props: {},
  computed: {},
  data () {
    return {
      selectPdfInfo: [],
      pdfItem: null,
      loading: true
    };
  },
  activated () {
    axiosServer({
      url: urls.apply + '/' + this.$route.query.applyId,
      params: this.reqBody //将参数设置为变量
    })
      .then(resp => {
        this.loading = false;
        if (resp.data.code == 0) {
          this.pdfItem = resp.data.entity;
          if (this.pdfItem.attachment) {
            this.pdfItem.attatchmentStr =
              (process.env.NODE_ENV == 'development' ? urls.picUrl2 : urls.picUrl2) + this.pdfItem.attachment;
          }
          setTimeout(() => {
            this.downloadPdf();
          }, 500);
        }
      })
      .catch(e => {
        this.loading = false;
      });
  },
  mounted () { },
  methods: {
    downloadPdf () {
      this.pdfItem.seasonStr = '';
      this.pdfItem.operatorsStr = '';
      if (this.pdfItem.id >= 2687) {
        let season = JSON.parse(this.pdfItem.season);
        if (season) {
          season.forEach(s => {
            if (s.s != null) {
              this.pdfItem.seasonStr += s.season + '(' + s.s + ' - ' + s.e + '月)；';
            } else {
              this.pdfItem.seasonStr += ' ' + s.season + ' -'
            }
          });
          this.pdfItem.seasonStr = this.pdfItem.seasonStr.substring(0, this.pdfItem.seasonStr.length - 1);
        }
      } else {
        this.pdfItem.seasonStr = this.pdfItem.season;
      }

      if (this.pdfItem.id >= 2687) {
        let operators = JSON.parse(this.pdfItem.operators);
        if (operators) {
          let length = operators.length;
          for (let i = 0; i < length; i++) {
            this.pdfItem.operatorsStr = this.pdfItem.operatorsStr + operators[i];
            if (i != length - 1) {
              this.pdfItem.operatorsStr = this.pdfItem.operatorsStr + ',';
            }
          }
          // operators.forEach(s => {});
        }
      }

      for (let p in this.pdfItem) {
        let pdfInfoOne = { key: p, value: this.pdfItem[p] };
        this.selectPdfInfo.push(pdfInfoOne);
      }
      this.$forceUpdate();
      setTimeout(() => {
        this.getPdf(
          this.$refs.pdfDom,
          this.$refs.innerDom,
          this.pdfItem.prjName + '-' + formatDate(new Date(), 'yyyyMMdd-hhmmss')
        );
      }, 2000);
    }
  }
};
</script>

<style>
.yemei {
  /* 页眉两边各20px距离 */
  width: 553px;
  border-bottom: #d6d5d5 solid 1px;
  font-size: 9px;
  line-height: 30px;
  padding-right: 30px;
  color: #9c9898;
  float: right;
  display: block;
  text-align: right;
  margin-right: 20px;
}

.bottomLine50 {
  display: inline-block;
  width: 50px;
  border-bottom: black solid 1px;
}
.bottomLine25 {
  display: inline-block;
  width: 25px;
  border-bottom: black solid 1px;
}

.docTitle {
  width: 593px;
  display: block;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  padding-left: 50px;
  padding-right: 50px;
  color: #000;
}

.innerPdfDomClass {
  position: fixed;
  overflow: auto;
  padding: 0;
  column-gap: 0px;
  column-fill: auto;
  padding-top: 20px;
}

.pdfDomClass {
  background: #fffffe;
  position: fixed;
  width: 593px;
  left: 0px !important;
  top: 0px;
  overflow: auto;
}

.pdf-line {
  /* //这里要减去40，以为设置了margin-left 和 margin-right  */
  width: 553px;
  border: solid 1px #000;
  border-bottom: none;
  line-height: 25px;
  margin-left: 20px;
  margin-right: 20px;
  padding-left: 10px;
  padding-right: 10px;
}

.pdf-title {
  min-width: 90px !important;
  color: #000;
  font-weight: bold;
  font-size: 12px;
  min-width: 150px;
}

.font12 {
  font-size: 12px;
}

.pdf-content {
  font-family: sans-serif;
  font-size: 12px;
  color: #000;
  font-weight: lighter;
}
</style>

<style scoped>
.title-class2 {
  min-width: 130px;
}

.opButton {
  padding: 2px;
  width: 65px;
  margin-left: 5px;
  margin-top: 5px;
}
.proj-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
  padding: 0px;
  margin-bottom: 0px;
}
</style>
